/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Meta_DescInputs */

const en_cp_meta_desc = /** @type {(inputs: Cp_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A one-semester program for student teams: build a business or solve a real problem with a PRD, tasks with pass/fail criteria, and evidence approved by the lecturer. IDR 299k per team per semester. Class, community, and campus partnerships.`)
};

const id_cp_meta_desc = /** @type {(inputs: Cp_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program satu semester untuk tim mahasiswa: bangun bisnis atau pecahkan masalah nyata dengan PRD, task berkriteria, dan bukti yang disetujui dosen. Rp 299 rb per tim per semester. Kerjasama kelas, komunitas, dan kampus.`)
};

/**
* | output |
* | --- |
* | "A one-semester program for student teams: build a business or solve a real problem with a PRD, tasks with pass/fail criteria, and evidence approved by the le..." |
*
* @param {Cp_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_meta_desc = /** @type {((inputs?: Cp_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_meta_desc(inputs)
	return en_cp_meta_desc(inputs)
});